export default __webpack_public_path__ + "static/media/blasphemy.10d8dcbd.png";